export const menuAccionFindingsSelectbuttons = [
  { label: 'Added manually', value: 'Added manually' },
  { label: 'Removed', value: 'Removed' },
];
